import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {DictAlias} from '../dict-panel/dict-alias.model';
import {FormControl, FormGroup} from '@angular/forms';
import {CustomValidators} from 'app/core/validator/custom-validators';
import {AlertService} from '@widgets/alert/alert.service';
import {TranslateService} from '@ngx-translate/core';
import {ValidatorService} from '@core/validator/validator.service';
import {DictAliasService} from '@core/ecv-http-services/services/dict-alias.service';
import {CreateDictAlias} from '../dict-panel/create-dict-alias.model';
import {DictPanelComponent} from '../dict-panel/dict-panel.component';

@Component({
  selector: 'dialog-dict-alias',
  templateUrl: './dialog.dict-alias.component.html'
})
export class DialogDictAliasComponent implements OnInit {

  parent: DictPanelComponent;
  addDictForm: FormGroup;
  model: DictAlias;

  constructor(public activeModal: NgbActiveModal,
              private translateService: TranslateService,
              private alertService: AlertService,
              public changeRef: ChangeDetectorRef,
              private validatorService: ValidatorService,
              private dictAliasService: DictAliasService) {
  }

  ngOnInit() {
    this.createForm();
    this.model = new DictAlias();
  }

  close() {
    this.activeModal.close(false);
  }

  dismiss(s: string) {
    this.activeModal.dismiss(s);
  }

  save() {
    this.validatorService.validate(this.addDictForm);
    if (!this.validatorService.isValid(this.addDictForm)) {
      return;
    }
    this.dictAliasService.createAlias(new CreateDictAlias(this.parent.currentSkill.id, this.model.description, this.model.descriptionEng))
      .subscribe(response => {
        this.model = response;
        this.parent.dictAliases.push(response);
        this.activeModal.close(true);
      });
  }

  private createForm() {
    this.addDictForm = new FormGroup({
      'description': new FormControl('', CustomValidators.notEmpty),
      'descriptionEng': new FormControl('', CustomValidators.notEmpty)
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/dialog/dialog.dict-alias.component.ts